import ng from 'angular';
import { BundleHelperService } from '@/services';
import { BundleApi } from '@/types/bundle-api';
import { MoleculeFormEditController } from '@/atomic-components/molecules/forms/form-edit/form-edit';

export class MoleculePanelCreateBundleExtensionController implements ng.IController {
    public static $inject: string[] = ['bundleHelper'];

    public $editFormMolecule: MoleculeFormEditController;
    public availableExtensions: BundleApi.BundleContingentExtension[];
    public productNames: Record<string, string>;
    public newExtensions: BundleApi.BundlePurchasedContingentExtension[];
    public opened: boolean;

    public selectedProductCode: string;
    public dropdownItems: { value: string; name: string }[] = [];

    constructor(private bundleHelper: BundleHelperService) {}

    public $onInit(): void {
        this.$editFormMolecule.saveCallback = this.addExtension;
        this.rebuildDropdownItems();
    }

    public $onChanges(changes: ng.IOnChangesObject): void {
        if (changes.availableExtensions || changes.productNames) {
            this.rebuildDropdownItems();
        }
    }

    private rebuildDropdownItems = (): void => {
        this.dropdownItems = (this.availableExtensions ?? []).map((ext) => {
            const code = ext.productCode ?? '';
            return {
                value: code,
                name: this.productNames?.[code] || code,
            };
        });
    };

    public get selectedExtensionInfo(): string {
        return this.bundleHelper.formatContingentExtensionInfo(
            this.selectedProductCode,
            this.availableExtensions,
            this.productNames,
        );
    }

    public close = (): void => {
        this.selectedProductCode = undefined;
        this.opened = false;
    };

    public get disableConfirmButton(): boolean {
        return this.$editFormMolecule.$invalid || !this.selectedProductCode;
    }

    public addExtension = (): void => {
        if (!this.selectedProductCode) {
            return;
        }
        this.newExtensions.push({
            productCode: this.selectedProductCode,
            quantity: 1,
        });
        this.close();
    };
}

export class MoleculePanelCreateBundleExtensionComponent implements ng.IComponentOptions {
    public bindings = {
        availableExtensions: '<',
        productNames: '<?',
        newExtensions: '=',
        opened: '=',
    };
    public require = {
        $editFormMolecule: '^moleculeFormEdit',
    };
    public controller = MoleculePanelCreateBundleExtensionController;
    public template = require('./panel-create-bundle-extension.html');
}
